import { Outlet } from 'react-router'
import { AddNumbersProvider } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/context/addNumbersContext'

export const AddNumbersProviderLayout = () => {
  return (
    <AddNumbersProvider>
      <Outlet />
    </AddNumbersProvider>
  )
}
